import script from "./ActionDropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./ActionDropdown.vue?vue&type=script&lang=ts&setup=true"

import "./ActionDropdown.vue?vue&type=style&index=0&id=4c246c10&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c246c10"]])

export default __exports__